import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import ClassifierGroup from '../interfaces/classifierGroup';
import Paginate from '../interfaces/paginate';
import ClassifierValue from '../interfaces/classifierValue';
import Classifier from '../interfaces/classifier';

export class InternalClassifierService extends HttpClient {
  index(groupKey: string): Observable<ClassifierGroup> {
    return this.get<ClassifierGroup>(
      `/api/internal/classifier-groups/${groupKey}`
    );
  }

  classifier(
    groupKey: string,
    classifierId: string,
    parentValueId?: string
  ): Observable<Classifier> {
    let url = parentValueId
      ? `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}/values/${parentValueId}`
      : `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}`;

    return this.get<Classifier>(url);
  }

  classifierByParentId(
    groupKey: string,
    parentId: string
  ): Observable<Classifier> {
    return this.get<Classifier>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/parent/${parentId}`
    );
  }

  value(
    groupKey: string,
    id: string,
    parentValueId?: string
  ): Observable<ClassifierValue> {
    let url = parentValueId
      ? `/api/internal/classifier-groups/${groupKey}/classifiers/values/${id}/parent/${parentValueId}`
      : `/api/internal/classifier-groups/${groupKey}/classifiers/values/${id}`;

    return this.get<ClassifierValue>(url);
  }

  update(
    groupKey: string,
    id: string,
    classifierValue: ClassifierValue
  ): Observable<ClassifierValue> {
    return this.put<ClassifierValue>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/values/${id}/update`,
      classifierValue
    );
  }

  store(
    classifierValue: ClassifierValue,
    classifierId: string,
    groupKey: string,
    parentValueId?: string
  ): Observable<ClassifierValue> {
    let url = `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}/values/create`;

    if (parentValueId) {
      url = `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}/values/parent/${parentValueId}/create`;
    }
    return this.post<ClassifierValue>(url, classifierValue);
  }

  allValues(groupKey: string, classifierId: string): Observable<[]> {
    return this.get<[]>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}/values/all`
    );
  }

  values(
    groupKey: string,
    classifierId: string,
    page: number = 1,
    sort?: string,
    desc: boolean = false,
    filter?: { [key: string]: any }
  ): Observable<Paginate<ClassifierValue>> {
    return this.get<Paginate<ClassifierValue>>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/${classifierId}/values`,
      {
        page,
        sort,
        desc,
        ...filter,
      }
    );
  }

  allValuesByParentValueId(groupKey: string, parentId: string): Observable<[]> {
    return this.get<[]>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/values/parent/${parentId}/all`
    );
  }

  valuesByParentId(
    groupKey: string,
    parentId: string,
    page: number = 1,
    sort?: string,
    desc: boolean = false
  ): Observable<Paginate<ClassifierValue>> {
    return this.get<Paginate<ClassifierValue>>(
      `/api/internal/classifier-groups/${groupKey}/classifiers/values/parent/${parentId}`,
      {
        page,
        sort,
        desc,
      }
    );
  }
}
